import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import {
  ExploreMarketplaceMembershipAPI,
  GetMarketPlaceMembershipAPI,
  ManageSubscriptionAPI,
} from "../../Utils/Api/MarketPlaceMembershipApi";
import { userId } from "../../Utils/LocalStorage";
import ExploreMarketplace from "../ExploreMarketplace/ExploreMarketplace";
import Modals from "../../Components/Modals/Modals";
import Warning from "../../assets/Warning.svg";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { CancelMarketplaceReqApi } from "../../Utils/Api/CancelMarketplaceReqApi";

const MarketplaceMembership = () => {
  const [membershipData, setMembershipData] = useState([]);
  const [modalFlag, setModalFlag] = useState(0);
  const [exploreMembershipData, setExploreMembershipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);
  const [ExploreFlag, setExploreFlag] = useState(false);
  const [categorySelect, setCategorySelect] = useState("");
  const [categoryApplyFlag, setCategoryApplyFlag] = useState(false);
  const [modalShow, setModalShow] = useState({
    state: false,
    category_id: "",
    cityId: "",
  });
  const [checkEligibility, setCheckEligibility] = useState(false);
  const [mandatoryError, setMandatoryError] = useState("");

  const buid = parseInt(userId());

  const navigate = useNavigate();

  const onCategorySelect = (e, cityId) => {
    let val = e.target.value;
    setCategorySelect(val);
    setCategoryApplyFlag(true);
    ApplyHandlerAPI("change_category", cityId, val);
  };

  const GetMarketPlaceMembership = async () => {
    const data = {
      bu_id: buid,
    };
    setLoading(true);
    const MarketplaceMembershipData = await GetMarketPlaceMembershipAPI(
      data,
      () => {
        navigate("/");
      }
    );
    if (MarketplaceMembershipData.status == 429) {
      setLoading(true);
      toast.error(MarketplaceMembershipData.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else if (MarketplaceMembershipData.mandatory_status === false) {
      setMandatoryError(MarketplaceMembershipData.mandatory_message);
    } else {
      setMembershipData(MarketplaceMembershipData.cities_with_status);
      setLoading(false);
    }
  };

  const UnsubscribeHandler = () => {
    const cityId = modalShow.cityId;
    const catId = modalShow.category_id;
    ApplyHandlerAPI("unsubscribe", cityId, catId);
  };

  const ReApplyHandler = () => {
    ApplyHandlerAPI("re_apply", modalShow.cityId, modalShow.category_id);
  };

  const CancelAPIHandler = async () => {
    const data = {
      bu_id: buid,
      city_id: modalShow.cityId,
    };
    setBtnLoading(true);
    const CancelAPIRes = await CancelMarketplaceReqApi(data, () => {
      navigate("/");
    });
    if (CancelAPIRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setBtnLoading(false);
    } else {
      if (CancelAPIRes.success === true) {
        toast.success(CancelAPIRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setModalShow((ps) => {
          return { ...ps, state: false, category_id: "", cityId: "" };
        });
        setCategoryApplyFlag(false);
        GetMarketPlaceMembership();
        ExploreMarketplaceMembership();
        setBtnLoading(false);
      } else if (CancelAPIRes.status === 429) {
        setLoading(true);
        toast.error(CancelAPIRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error(CancelAPIRes.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setBtnLoading(false);
      }
    }
  };

  const ExploreMarketplaceMembership = async (searchVal) => {
    const data = {
      bu_id: buid,
      search_value: searchVal,
    };

    if (!searchVal) {
      setLoading(true);
    }
    const ExploreMarketplaceMembershipData =
      await ExploreMarketplaceMembershipAPI(data, () => {
        navigate("/");
      });
    if (ExploreMarketplaceMembershipData === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      if (ExploreMarketplaceMembershipData.success === true) {
        setExploreMembershipData(
          ExploreMarketplaceMembershipData.cities_with_description
        );
        setCheckEligibility(
          ExploreMarketplaceMembershipData.create_marketplace_eligible
        );
        setLoading(false);
      } else if (ExploreMarketplaceMembershipData.status == 429) {
        setLoading(true);
        toast.error(ExploreMarketplaceMembershipData.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        setExploreMembershipData([]);
        setCheckEligibility(false);
        setLoading(false);
      }
    }
  };

  const ExploreMarketPlaceHandler = () => {
    setExploreFlag(true);
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };

  const ApplyHandlerAPI = async (applyStatus, cityId, CategoryId) => {
    const data = {
      bu_id: buid,
      city_id: cityId,
      category_id: parseInt(CategoryId),
      action: applyStatus,
    };
    setBtnLoading(true);
    const ManageSubscriptionRes = await ManageSubscriptionAPI(data, () => {
      navigate("/");
    });
    if (ManageSubscriptionRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setBtnLoading(false);
    } else {
      if (ManageSubscriptionRes.success === true) {
        toast.success(ManageSubscriptionRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setCategoryApplyFlag(false);
        setModalShow({ state: false, category_id: "", cityId: "" });
        GetMarketPlaceMembership();
        ExploreMarketplaceMembership();
        setBtnLoading(false);
      } else if (ManageSubscriptionRes.status === 429) {
        setLoading(true);
        toast.error(ManageSubscriptionRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error(ManageSubscriptionRes.message, {
          position: "top-center",
          autoClose: applyStatus === "re_apply" ? 10000 : 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setBtnLoading(false);
      }
    }
  };

  useEffect(() => {
    GetMarketPlaceMembership();
    ExploreMarketplaceMembership();
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="table-responsive-xl black-header">
        {mandatoryError ? (
          <p className="ai-error-two">{mandatoryError}</p>
        ) : null}
        <table
          className={
            mandatoryError
              ? "recentact-table mt-3 table ver-middle manage-vou-table text-center explore-main-table blurredtable"
              : "recentact-table mt-3 table ver-middle manage-vou-table text-center explore-main-table"
          }
        >
          <thead className="text-white">
            <tr>
              <th width="300px">Marketplace</th>
              <th>Status</th>
              <th>Total Voucher Transaction Fees</th>
              <th>Category</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="membership-table-body">
            {membershipData?.length != 0 ? (
              membershipData?.map((data, index) => {
                const Actions = () => {
                  if (data.status === "Published") {
                    return (
                      <>
                        <Link
                          className=""
                          onClick={() => {
                            setModalShow({
                              state: true,
                              category_id: data.category_id,
                              cityId: data.city_id,
                            });
                            setModalFlag(0);
                          }}
                        >
                          <p
                            className="ModalPopUpButton unsubscribe-btn"
                            variant="primary"
                            // onClick={() => setModalShow(true)}
                          >
                            Unsubscribe
                          </p>
                        </Link>
                      </>
                    );
                  }
                  if (data.status === "Declined") {
                    return (
                      <Link
                        className="unsubscribe-btn"
                        onClick={() => {
                          setModalShow({
                            state: true,
                            category_id: data.category_id,
                            cityId: data.city_id,
                          });
                          setModalFlag(1);
                        }}
                      >
                        Re-Apply
                      </Link>
                    );
                  }
                  if (data.status === "New") {
                    return (
                      <Link
                        className=""
                        onClick={() => {
                          setModalShow({
                            state: true,
                            cityId: data.city_id,
                          });
                          setModalFlag(2);
                        }}
                      >
                        <p
                          className="ModalPopUpButton unsubscribe-btn"
                          variant="primary"
                          // onClick={() => setModalShow(true)}
                        >
                          Cancel
                        </p>
                      </Link>
                    );
                  }
                  if (data.status === "In Review") {
                    return (
                      <Link
                        className=""
                        onClick={() => {
                          setModalShow({
                            state: true,
                            cityId: data.city_id,
                          });
                          setModalFlag(2);
                        }}
                      >
                        <p
                          className="ModalPopUpButton unsubscribe-btn"
                          variant="primary"
                          // onClick={() => setModalShow(true)}
                        >
                          Cancel
                        </p>
                      </Link>
                    );
                  }
                };

                const ActionsBtn = Actions();

                return (
                  <tr key={index} className="marketplace-explore-tr">
                    <td
                      className="text-center text-limit-2"
                      title={data.market_place}
                    >
                      {data.market_place}
                    </td>
                    <td>
                      {data.status === "Published" ? "Approved" : data.status}
                    </td>
                    <td>{data.transaction_fee}%</td>
                    <td>
                      {" "}
                      <Form.Select
                        aria-label="Default select example"
                        className="custom-select"
                        onChange={(e) => onCategorySelect(e, data.city_id)}
                        value={
                          categoryApplyFlag === true
                            ? categorySelect
                            : data.category_id
                        }
                        // value={UserData.bu_cat_id}
                        // value={
                        //   editInputFlag.editFlagBusinessCategory === true
                        //     ? userInput.editBusinessCategory
                        //     : UserData.bu_cat_id
                        // }
                      >
                        {data.all_categories?.length > 0 ? (
                          data.all_categories.map((val) => {
                            return (
                              <option value={val.category_id}>
                                {val.category_name}
                              </option>
                            );
                          })
                        ) : (
                          <option value="0">{"No categories"}</option>
                        )}
                      </Form.Select>
                    </td>
                    <td>{ActionsBtn}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={5} className="text-center">
                  <p className="no-record">No records available!</p>
                </td>
              </tr>
            )}
            <tr className="my -4">
              <td colSpan={9} className="table-viewall pt-4">
                <button
                  onClick={ExploreMarketPlaceHandler}
                  type="button"
                  className="green-btn mt-0 btn btn-primary"
                >
                  Explore Marketplace
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        {ExploreFlag === true ? (
          <ExploreMarketplace
            ExploreMarketplaceData={exploreMembershipData}
            SearchAPIFuc={ExploreMarketplaceMembership}
            MarketMembershipAPIFuc={GetMarketPlaceMembership}
            CheckEligibility={checkEligibility}
          />
        ) : (
          <></>
        )}
      </div>
      <Modals
        loading={btnloading}
        show={modalShow.state}
        onHide={() =>
          setModalShow((ps) => {
            return { ...ps, state: false, category_id: "", cityId: "" };
          })
        }
        images={Warning}
        description={`Are you sure you want to ${
          modalFlag === 0
            ? "Unsubscribe"
            : modalFlag === 1
            ? "Re-Apply"
            : "Cancel"
        }?`}
        firstbutton="No"
        secondbutton="Yes"
        UnsubscribeHandler={
          modalFlag === 0
            ? UnsubscribeHandler
            : modalFlag === 1
            ? ReApplyHandler
            : CancelAPIHandler
        }
      />
    </>
  );
};

export default MarketplaceMembership;
